import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import { AccessibilityHelper } from "../GlobalAssets/js/accessibilityHelper";

class KeyCaseStudies {
  constructor(component) {
    this.refs = {
      slider: '.js-projects-slider',
      prev: '.js-prev',
      next: '.js-next',
      slide: '.js-slide',
    };
    
    this.dom = {
      $slider: component.querySelector(this.refs.slider),
      $prev: component.querySelector(this.refs.prev),
      $next: component.querySelector(this.refs.next),
      $slides: component.querySelectorAll(this.refs.slide),
    };

    this.state = {
      swiper: null,
      accessibilityHelper: new AccessibilityHelper(),
    };

    this.mount();
  }

  mount() {
    const { dom, state} = this;

    const options = {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 10,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      watchSlidesProgress: true,
      navigation: {
        prevEl: dom.$prev,
        nextEl: dom.$next,
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 15,
          spaceBetween: 0,
        },
        1024: {
          allowTouchMove: false,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 25,
          spaceBetween: 0,
        }
      },
      on: {
        afterInit: (swiper) => {
          swiper.loopFix();
        },
        slideChangeTransitionEnd: (swiper) => {
          swiper.loopFix();
          this.setViewableSlides(swiper);
        },
        reachEnd: (swiper) => {
          this.setViewableSlides(swiper);
        },
        fromEdge: (swiper) => {
          this.setViewableSlides(swiper);
        }
      }
    };

    if (dom.$slides.length < 2) {
      options.slidesPerView = 1;
    }

    // Initialize Swiper slider
    state.swiper = new Swiper(dom.$slider, options);
    this.setViewableSlides(state.swiper);
  }

  setViewableSlides({ activeIndex, slides }) {
    const { state } = this;

    slides.forEach((slide) => {
      state.accessibilityHelper.updateElementAccessibility(slide, false);
      slide.setAttribute('aria-hidden', 'true');

      if (slide.classList.contains('swiper-slide-fully-visible')) {
        this.setViewableSlide(slide);
      }
    });
  }

  setViewableSlide(slide) {
    slide.setAttribute('aria-hidden', 'false');

    const visibleElements = slide.querySelectorAll('a, button, input, select, textarea');
    visibleElements.forEach(($el) => {
      $el.removeAttribute('tabindex');
      $el.setAttribute('aria-hidden', 'false');
    });
  }
}

const $keyCaseStudies = document.querySelector('.js-key-case-studies');
if ($keyCaseStudies) new KeyCaseStudies($keyCaseStudies);